export default {
    gpsStatusDiffTime: (state) => {
        var nowTime = new Date().getTime();
        return nowTime - state.gpsStatus.timeStamp;
    },
}